<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Gestión de Campamento">
          <GestionLista @open="open()" @close="close()"></GestionLista>
        </BaseCard>
      </v-col>
    </v-row>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Gestion',
  components: {
    GestionLista: () => import('../components/GestionLista')
  },
  data: () => ({
    showLoading: false,
    page: {
      title: 'Campamento'
    },
    breadcrumbs: [
      {
        text: 'Gestión de Campamento',
        disabled: true
      },
      {
        text: 'Listado',
        disabled: true
      }
    ]
  }),
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    }
  }
};
</script>
